/** Strip markdown / CM emphasis before applying plain text into hosts. */
export function stripMarkdownNoise(text: string): string {
  let s = String(text ?? "");
  s = s.replace(/\*\*([^*]+)\*\*/g, "$1");
  s = s.replace(/__([^_]+)__/g, "$1");
  s = s.replace(/~~([^~]+)~~/g, "$1");
  s = s.replace(/\*([^*\n]+)\*/g, "$1");
  s = s.replace(/_([^_\n]+)_/g, "$1");
  s = s.replace(/`([^`]+)`/g, "$1");
  s = s.replace(/\{(?:fs|ff|align|dir):[^}]+\}/g, "");
  s = s.replace(/\{\/(?:fs|ff|align|dir)\}/g, "");
  s = s.replace(/^#{1,6}\s+/gm, "");
  s = s.replace(/^<!--cm-table:.*?-->\s*/gm, "");
  return s;
}

/** Persian / ZWNJ search variants for host find APIs. */
export function normalizeSearchVariants(find: string): string[] {
  const base = stripMarkdownNoise(find).trim();
  if (!base) return [];
  const variants = new Set<string>([base]);
  variants.add(base.replace(/\u200c/g, ""));
  variants.add(base.replace(/\u200c/g, " "));
  variants.add(base.replace(/\s+/g, " "));
  variants.add(base.replace(/ي/g, "ی").replace(/ك/g, "ک"));
  if (base.length > 80) {
    variants.add(base.slice(0, 60).trim());
    variants.add(base.slice(-60).trim());
  }
  return [...variants].filter((v) => v.length >= 2);
}
